import { render, staticRenderFns } from "./ConnectFacebook.vue?vue&type=template&id=5622b050&"
import script from "./ConnectFacebook.vue?vue&type=script&lang=js&"
export * from "./ConnectFacebook.vue?vue&type=script&lang=js&"
import style0 from "./ConnectFacebook.vue?vue&type=style&index=0&id=5622b050&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports